<template>
  <section id="intro" v-if="site">

    <header @click="$router.push({name: 'Collections'})">
      <transition :name="titleTransition">
        <div class="title" v-show="!siteIntro && !notesVisible">
          <h1 class="h1"><router-link :to="{name: 'Collections'}">{{headerText}}</router-link></h1>
          <h2 class="h5 century-mono"><router-link :to="{name: 'Collections'}">{{subheaderText}}</router-link></h2>
        </div>
      </transition>
      <cinemagraph :site="site" :blur="siteIntro || notesVisible || blurVideo" @playing="cinemagraphPlaying"></cinemagraph>
    </header>
      
    <transition name="fade">
      <router-view :mobile="mobile" :site="site"></router-view>
    </transition>
    
    <transition :name="titleTransition">
      <router-link v-show="!siteIntro" :to="{name: 'Notes'}" class="intro__asterisk">
        <span class="icon-asterisk"></span>
      </router-link>
    </transition>
  </section>
</template>

<script>
import Vue from 'vue'
import Cinemagraph from './VideoBackground'
import Footerr from './Footer'
export default {
  name: 'intro',
  props: ['mobile', 'siteIntro', 'site', 'collections'],
  components: {
    Cinemagraph,
    Footerr
  },
  data () {
    return {
      blurVideo: true
    }
  },
  metaInfo () {
    return {
      meta: [
        {name: 'description', content: this.site ? this.site.getText('site.meta_description') : ''},
        {name: 'keywords', content: this.site ? this.site.getText('site.meta_keywords') : ''},
        {property: 'og:title', content: document.title ? document.title : 'Dovedale Design Studio'},
        {property: 'og:description', content: this.site ? this.site.getText('site.meta_description') : ''},
        {property: 'og:image', content: this.site ? this.site.data['site.share_image'].value.main.url : ''},
        {name: 'twitter:title', content: this.site ? this.site.getText('site.tagline') : ''},
        {name: 'twitter:title', content: document.title ? document.title : 'Dovedale Design Studio'},
        {name: 'twitter:description', content: this.site ? this.site.getText('site.meta_description') : ''},
        {name: 'twitter:image:src', content: this.site ? this.site.data['site.share_image'].value.main.url : ''},
        {itemprop: 'name', content: document.title ? document.title : 'Dovedale Design Studio'},
        {itemprop: 'description', content: this.site ? this.site.getText('site.meta_description') : ''},
        {itemprop: 'image', content: this.site ? this.site.data['site.share_image'].value.main.url : ''}
      ]
    }
  },
  computed: {
    headerText () {
      return this.site ? this.site.getText('site.header') : ''
    },
    subheaderText () {
      return this.site ? this.site.getText('site.subheader') : ''
    },
    notesVisible () {
      return this.$route.name === 'Notes'
    },
    titleTransition () {
      return this.siteIntro ? 'longfade' : 'fadeinplace'
    }
  },
  watch: {
    '$route' (to, from) {
      this.$emit('toggleNav')
    },
    site () {
      this.updateMeta()
    }
  },
  methods: {
    isHidden (item) {
      return item.data['collection.hide-on-index'] ? item.getBoolean('collection.hide-on-index') : false
    },
    showNotes () {
      this.$router.push({name: 'Notes'})
    },
    cinemagraphPlaying () {
      this.blurVideo = false
      this.$emit('cinemagraph-playing')
    },
    updateMeta () {
      Vue.updateMeta.setTitle()
      Vue.updateMeta.setDescription()
    }
  },
  created () {
    if (this.$route.name === 'Notes') this.$emit('toggleNav')
    this.updateMeta()
  }
}
</script>

<style lang="scss" scoped>
@import '../style/variables';
#intro{
  color: $white;
  background:$black;
  overflow:hidden;

  > header{
    position:relative;
    z-index:1;
    height:100vh;
    cursor: pointer;
    @include vcenter_content($child:'.title');
    .title{
      position:relative;
      width:100%;
      z-index:10;
      h2 {
        margin-top: 1em;
      }
      // scale font size when gets squished on desktop
      @media (min-width:$bkpt-mobile + 1) and (max-width:860px) {
        font-size: $basefont / 860 * 100vw;
      }
    }
  }
}
.intro__asterisk{
  position: fixed;
  bottom:1.6rem;
  left:50%;
  transform:translateX(-50%);
  z-index:$z-nav;
  padding:1rem;
  display:block;
  line-height: 0;
}

// mobile
@include on_mobile() {

  #intro{
    background:$white;
    // padding-top: 3.8125em;

    > header{
      height:100vh; // calc(100vh - 3.8125em);
      z-index:10;
      h1{ @include h5(); }
      h2{ @include h7(); margin-top: .5em;}
    }

    .collections--list{
      padding:$gutter;
      article{
        position: relative;
        margin:0 0 $gutter;
        padding-bottom: 70.06125808%; // height
        header{
          @include background(absolute,100%);
          display:flex;
          align-items:center;
          justify-content:center;
          h3{
            line-height: 1.65;
          }
        }
      }
    }

    #footer{
      color:$black;
      border-top-style:solid;      
    }
  }
}
</style>



// WEBPACK FOOTER //
// Intro.vue?39ab9ea0